<template>
    <div>
        <rkm-table
            :items="items"
            :fields="fields.tables.tipo"
            :filter="filter"
            sort-by="nomeFantasia"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao'),
        }
    },
    data: () => ({
        items: [],
        filter: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleDestroy(item) {

            const destroy = async () => {

                if (item.alterado) {

                    item.faturamentoRelacionado.forEach(element => {

                        const objIndex = this.data.form.unidadesFaturamento.findIndex(unidade => unidade.infraestruturaId
                            == element.relacionadaInfraestruturaId)

                        if (objIndex >= 0) {
                            this.data.form.unidadesFaturamento.splice(objIndex, 1)
                        }
                    });
                } else {

                    this.setLoading()

                    this.repositories.parametrizacao.getUnidadeFaturamento(this.prepareData(item))
                        .then(({ data }) => {

                            data.faturamentoRelacionado.forEach(element => {

                                const objIndex = this.data.form.unidadesFaturamento.findIndex(unidade => unidade.infraestruturaId
                                    == element.relacionadaInfraestruturaId)

                                if (objIndex >= 0) {
                                    this.data.form.unidadesFaturamento.splice(objIndex, 1)
                                }
                            });
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }

                const index = this.data.model.unidadesFaturamento.findIndex((obj => obj.id == item.id));

                this.data.model.unidadesFaturamento.splice(index, 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir o local de coleta?', destroy)
        },
        prepareData(item) {

            const infraestruturaId = item.infraestruturaId

            return this.camelObjectKeysToSnakeRecursive({infraestruturaId})
        },
        handleClearFilter() {
            this.filter = null
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.unidadesFaturamento' (unidades) {
            this.items = unidades.map(unidade => {

                return {
                    id: unidade.id,
                    nomeFantasia: unidade.nomeFantasia,
                    infraestruturaNome: unidade.infraestruturaNome,
                    unidadeId: unidade.unidadeId,
                    infraestruturaId: unidade.infraestruturaId,
                    alterado: unidade.alterado,
                    profissionais: unidade.profissionais,
                    faturamentoRelacionado: unidade.faturamentoRelacionado,
                }
            })
        }
    }
}
</script>